import { DocumentResponse } from 'all-in-one-shared-api/dist/apis/documents/DocumentsResponse';

import { ClaimSettlementNoticeTableDataType } from 'pages/documents/types/documentsTypes';

import i18n from 'i18n';

export const formatClaimSettlementNotice = (
  settlementNotices: DocumentResponse[],
): ClaimSettlementNoticeTableDataType[] => {
  if (settlementNotices && settlementNotices.length > 0) {
    return settlementNotices.map((notice) => {
      const { documentDate, url } = notice;
      return {
        key: url ?? '',
        date: documentDate ?? '',
        description: i18n.t('documents.claimSettlementNotice'),
        url: url ?? '',
      };
    });
  }
  return [];
};
